/* FUT7 — filtro da coleção (sections/f7-c-filter.liquid; port do tnf-filter.js da TNF v8).
   O estado sai do próprio HTML (aria-pressed); cada toque monta a URL (tags no caminho, filtros nativos na query)
   e troca a grade e o painel pela Section Rendering API. O servidor continua sendo a fonte da verdade. */
(function(){
  var root = document.querySelector('[data-f7-cf]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var secId = root.dataset.section, base = root.dataset.base;
  var sheet = root.querySelector('[data-f7-cf-sheet]'), panel = root.querySelector('[data-f7-cf-panel]');
  var barWrap = root.querySelector('[data-f7-cf-barwrap]'), bar = root.querySelector('[data-f7-cf-bar]');
  var gridSec = document.querySelector('[id^="shopify-section-"][id$="__product-grid"]');
  var gridId = gridSec ? gridSec.id.replace('shopify-section-', '') : '';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEEP = ['view', 'preview_theme_id'];

  /* 1. URL a partir do que está marcado */
  var pressed = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel + '[aria-pressed="true"]')); };
  var build = function(){
    var tags = [];
    pressed('[data-f7-cf-tag]').forEach(function(b){ if (tags.indexOf(b.dataset.f7CfTag) < 0) tags.push(b.dataset.f7CfTag); });
    var sp = new URLSearchParams(), cur = new URLSearchParams(location.search);
    KEEP.forEach(function(k){ if (cur.get(k)) sp.set(k, cur.get(k)); });
    pressed('[data-f7-cf-size]').forEach(function(b){ sp.append('filter.v.option.size', b.dataset.f7CfSize); });
    var pr = root.querySelector('[data-f7-cf-price]');
    if (pr) {
      var lo = +pr.querySelector('[data-f7-cf-pmin]').value, hi = +pr.querySelector('[data-f7-cf-pmax]').value, max = +pr.dataset.max;
      if (lo > 0) sp.set('filter.v.price.gte', lo);
      if (hi < max) sp.set('filter.v.price.lte', hi);
    }
    var so = pressed('[data-f7-cf-sort]')[0];
    if (so && !so.dataset.default) sp.set('sort_by', so.dataset.f7CfSort);
    var q = sp.toString();
    return base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '') + (q ? '?' + q : '');
  };

  /* 2. Busca a nova grade e o novo painel */
  var seq = 0, tLoad = null;
  var swap = function(sel, from){
    var a = root.querySelector(sel), b = from.querySelector(sel);
    if (a && b) a.innerHTML = b.innerHTML;
    return [a, b];
  };
  var load = function(url, push){
    var my = ++seq;
    root.classList.add('is-loading');
    if (gridSec) gridSec.classList.add('f7-cf-dim');
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(secId + (gridId ? ',' + gridId : ''));
    return fetch(u).then(function(r){ return r.json(); }).then(function(d){
      if (my !== seq) return;
      var dp = new DOMParser();
      if (gridId && d[gridId]) {
        var g = dp.parseFromString(d[gridId], 'text/html').body.firstElementChild;
        if (g) gridSec.innerHTML = g.innerHTML;
        document.dispatchEvent(new CustomEvent('f7:grid:updated'));
      }
      if (d[secId]) {
        var f = dp.parseFromString(d[secId], 'text/html');
        var body = root.querySelector('[data-f7-cf-body]'), st = body ? body.scrollTop : 0;
        swap('[data-f7-cf-chips]', f);
        swap('[data-f7-cf-body]', f);
        if (body) body.scrollTop = st;
        var nA = root.querySelector('[data-f7-cf-n]'), nB = f.querySelector('[data-f7-cf-n]');
        if (nA && nB) { nA.textContent = nB.textContent; nA.hidden = nB.hidden; }
        var gA = root.querySelector('.f7-cf-go'), gB = f.querySelector('.f7-cf-go');
        if (gA && gB) { gA.textContent = gB.textContent; gA.dataset.f7CfCount = gB.dataset.f7CfCount; }
        var cA = root.querySelector('[data-f7-cf-clearbtn]'), cB = f.querySelector('[data-f7-cf-clearbtn]');
        if (cA && cB) cA.disabled = cB.disabled;
        initPrice();
      }
      if (push !== false) history.pushState({ f7cf: 1 }, '', url);
    }).catch(function(){ location.href = url; }).then(function(){
      if (my !== seq) return;
      root.classList.remove('is-loading');
      if (gridSec) gridSec.classList.remove('f7-cf-dim');
    });
  };
  var apply = function(wait){ clearTimeout(tLoad); tLoad = setTimeout(function(){ load(build()); }, wait || 0); };
  window.addEventListener('popstate', function(){ location.reload(); });

  /* 3. Toques: tags (uma por grupo), tamanhos (várias), ordem (uma), limpar */
  var setPressed = function(b, on){ b.setAttribute('aria-pressed', on); b.classList.toggle('is-on', on); };
  root.addEventListener('click', function(e){
    var t = e.target.closest('[data-f7-cf-tag]');
    if (t) {
      var on = t.getAttribute('aria-pressed') !== 'true', tag = t.dataset.f7CfTag, g = t.dataset.f7CfG;
      root.querySelectorAll('[data-f7-cf-g="' + g + '"]').forEach(function(b){ setPressed(b, on && b.dataset.f7CfTag === tag); });
      apply(t.closest('[data-f7-cf-sheet]') ? 120 : 0);
      return;
    }
    var s = e.target.closest('[data-f7-cf-size]');
    if (s) { setPressed(s, s.getAttribute('aria-pressed') !== 'true'); apply(160); return; }
    var o = e.target.closest('[data-f7-cf-sort]');
    if (o) { root.querySelectorAll('[data-f7-cf-sort]').forEach(function(b){ setPressed(b, b === o); }); apply(); return; }
    if (e.target.closest('[data-f7-cf-clear]')) {
      root.querySelectorAll('[aria-pressed="true"]').forEach(function(b){ if (!b.dataset.f7CfSort) setPressed(b, false); });
      var pr = root.querySelector('[data-f7-cf-price]');
      if (pr) { pr.querySelector('[data-f7-cf-pmin]').value = 0; pr.querySelector('[data-f7-cf-pmax]').value = pr.dataset.max; }
      apply();
      return;
    }
    if (e.target.closest('[data-f7-cf-open]')) { openSheet(); return; }
    if (e.target.closest('[data-f7-cf-close]')) { closeSheet(true); }
  });

  /* 4. Faixa de preço com dois controles */
  var initPrice = function(){
    var pr = root.querySelector('[data-f7-cf-price]');
    if (!pr || pr.dataset.ready) return;
    pr.dataset.ready = '1';
    var a = pr.querySelector('[data-f7-cf-pmin]'), b = pr.querySelector('[data-f7-cf-pmax]'), max = +pr.dataset.max, sym = pr.dataset.sym;
    var fill = pr.querySelector('[data-f7-cf-pfill]'), lo = pr.querySelector('[data-f7-cf-plo]'), hi = pr.querySelector('[data-f7-cf-phi]');
    var paint = function(src){
      var x = +a.value, y = +b.value;
      if (x > y - 1) { if (src === a) a.value = x = Math.max(0, y - 1); else b.value = y = Math.min(max, x + 1); }
      fill.style.left = (x / max * 100) + '%'; fill.style.right = (100 - y / max * 100) + '%';
      lo.textContent = sym + x; hi.textContent = sym + y + (y >= max ? '+' : '');
    };
    [a, b].forEach(function(r){
      r.addEventListener('input', function(){ paint(r); });
      r.addEventListener('change', function(){ apply(80); });
    });
    paint();
  };
  initPrice();

  /* 5. Painel: abre/fecha, trava a rolagem, arrasta para baixo para fechar */
  var startUrl = '', secEl = root.closest('.shopify-section');
  var openSheet = function(){
    startUrl = build();
    if (secEl) secEl.style.zIndex = '2100';
    sheet.hidden = false;
    document.documentElement.classList.add('f7-cf-lock');
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    setTimeout(function(){ panel.focus({ preventScroll: true }); }, 50);
  };
  var closeSheet = function(scroll){
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('f7-cf-lock');
    panel.style.transform = '';
    setTimeout(function(){ sheet.hidden = true; if (secEl) secEl.style.zIndex = ''; }, reduce ? 0 : 320);
    if (scroll && build() !== startUrl) toResults();
  };
  var toResults = function(){
    var anchor = barWrap.getBoundingClientRect().top + window.scrollY - stickTop() - 4;
    if (window.scrollY > anchor + 10 || window.scrollY < anchor - window.innerHeight * 0.6) window.scrollTo({ top: anchor, behavior: reduce ? 'auto' : 'smooth' });
  };
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSheet(true); });
  var drag = root.querySelector('[data-f7-cf-drag]'), y0 = null, dy = 0;
  drag.addEventListener('touchstart', function(e){ y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
  drag.addEventListener('touchmove', function(e){ if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
  drag.addEventListener('touchend', function(){ panel.style.transition = ''; if (dy > 90) closeSheet(true); else panel.style.transform = ''; y0 = null; });

  /* 6. Barra fixa: acompanha o cabeçalho (que some ao rolar para baixo) e sai no fim da grade */
  var head = document.querySelector('[data-f7-nv]'), headSec = head && head.closest('.shopify-section');
  var stickTop = function(){ return head && headSec && !headSec.classList.contains('is-hidden') ? head.offsetHeight : 0; };
  var ticking = false;
  var onScroll = function(){
    ticking = false;
    var top = stickTop(), s = barWrap.getBoundingClientRect().top, end = gridSec ? gridSec.getBoundingClientRect().bottom : Infinity;
    var fix = s < top && end > top + bar.offsetHeight + 60;
    bar.classList.toggle('is-fixed', fix);
    bar.style.top = fix ? top + 'px' : '';
  };
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  if (headSec && window.MutationObserver) new MutationObserver(onScroll).observe(headSec, { attributes: true, attributeFilter: ['class'] });
  onScroll();
})();
